module.exports = __webpack_public_path__ + "static/media/260257.c539f3f8.png";